export const resolveCssVar = (name, fallback) => {
  if (typeof window === "undefined") {
    return fallback;
  }

  const value = getComputedStyle(document.documentElement).getPropertyValue(
    name,
  );
  return value?.trim() || fallback;
};

export const getDashboardColors = () => ({
  accentColor: resolveCssVar("--dashboard-accent-color", "#FCA43B"),
  accentHighlightColor: resolveCssVar(
    "--dashboard-accent-highlight",
    "#FDBE6D",
  ),
  successColor: resolveCssVar("--dashboard-success-color", "#85EEAD"),
  dangerColor: resolveCssVar("--dashboard-danger-color", "#ffb3c1"),
  chartRemainderColor: resolveCssVar(
    "--dashboard-chart-remainder-color",
    "#f3f4f6",
  ),
  totalQuestionsColor: resolveCssVar(
    "--dashboard-total-questions-color",
    "#D4F92D",
  ),
  chartColors: ["#FCA43B", "#D4F92D", "#85EEAD", "#FAEE70"],
});
